import React, { useEffect, useState } from 'react';
import {
  Grid,
  Box,
  Modal,
  Typography,
  Button,
  LinearProgress,
  TextField
} from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import {
  addTagScheme,
  getTagSchemeDetails,
  editTagScheme, deleteTagScheme
} from 'apis/device';

import TruckMuiSelect from "../MuiSelect/TruckMuiSelect";
import CommonUtil from "../../common/CommonUtil";
import ToastManager from "../../common/ToastManager";
import DeleteModal from "../../common/DeleteModal";

interface DeviceModalProps {
  open: boolean;
  handleClose: Function | any;
  getTagSchemeist: Function;
  schemeToEdit?: any;

}

const TagSchemeModal: React.FC<DeviceModalProps> = ({ open, handleClose, getTagSchemeist, schemeToEdit }) => {

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [tagStatuses, setTagStatuses] = useState<any>(CommonUtil.tagStatuses);
  const [trackIdErr, setTrackIdErr] = useState(true);
  const [schemeName, setSchemeName] = useState("");
  const [tagSchemeStatus, setTagSchemeStatus] = useState<any>(null);
  const [tagStatusError, setTagStatusError] = useState<any>(true);
  const [tagDesc, setTagDesc] = useState("");
  const [tagId, setTagId] = useState("");
  const [headerFormats, setHeaderFormats] = useState(CommonUtil.headerFormats);
  const [headerFormat, setHeaderFormat] = useState<any>(null);
  const [headerFormatError, setHeaderFormatError] = useState<any>(true);
  const [serialFormats, setSerialFormats] = useState(CommonUtil.serialFormat);
  const [serialFormat, setSerialFormat] = useState<any>(null);
  const [serialFormatError, setSerialFormatError] = useState<any>(true);
  const [headerLength, setHeaderLength] = useState("");
  const [headerLengthError, setHeaderLengthError] = useState(true);
  const [headerId, setHeaderId] = useState("");
  const [headerIdError, seteHaderIdError] = useState(true);
  const [serialLength, setSerialLength] = useState("");
  const [serialLengthError, setSerialLengthError] = useState(true);
  const [serialId, setSerialId] = useState("");
  const [serialIdError, setSerialIdError] = useState(true);
  const [delTagScheme, setDelTagSchme] = useState(false);

  useEffect(() => {
    if (schemeToEdit) {
      getDetails();
    } else {
      getAllData();
    }

  }, []);//schemeToEdit

  const getDetails = async () => {
    let data = await getTagSchemeDetails(schemeToEdit.tagSchemeId);
    console.log(data);
    if (data?.response?.data?.errorMessage) {
      ToastManager.showToast(data.response.data.errorMessage, "Error");
      return
    }
    if (data) {
     setSchemeName(data.tagSchemeName);
      setTrackIdErr(data.tagSchemeName ? false : true);
      setTagSchemeStatus({ key: data.tagSchemeStatus, value: data.tagSchemeStatus }); //#448
      setTagStatusError(data.tagSchemeStatus ? false : true);
      setTagDesc(data.description);
      setHeaderFormat({ key: data.headerFormat, value: data.headerFormat });
      setHeaderFormatError(data.headerFormat ? false : true);
      setHeaderId(data.headerId);
      seteHaderIdError(data.headerId ? false : true);
      setTagId(data.headerId + data.serialNumberId);
      setHeaderLength(data.headerLength);
      setHeaderLengthError(data.headerLength ? false : true);
      setSerialFormat({ key: data.serialNumberFormat, value: data.serialNumberFormat });
      setSerialFormatError(data.serialNumberFormat ? false : true);
      setSerialId(data.serialNumberId);
      setSerialIdError(data.serialNumberId ? false : true);
      setSerialLength(data.serialNumberLength);
      setSerialLengthError(data.serialNumberLength ? false : true);
    }
      }

  const getAllData = () => {
    setIsLoading(true);
    setIsLoading(false);
  }

  let getRequestObject = (): any => {
    if (!schemeName) {
      setTrackIdErr(true);
    }
    if (!tagSchemeStatus) {
      setTagStatusError(true);
    }
    if (!headerFormat) {
      setHeaderFormatError(true);
    }
    if (!serialFormat) {
      setSerialFormatError(true);
    }
    if (schemeName && tagSchemeStatus && tagId && headerFormat && serialFormat && headerLength && serialLength) {
      let reqObj: any = {};
      reqObj.description = tagDesc;
      reqObj.tagId = headerId + serialId;
      reqObj.tagSchemeStatus = tagSchemeStatus ? tagSchemeStatus.key : "";
      reqObj.tagSchemeName = schemeName;
      reqObj.headerFormat = headerFormat ? headerFormat.key : "";
      reqObj.headerId = headerId;
      reqObj.headerLength = headerLength;
      reqObj.serialNumberFormat = serialFormat ? serialFormat.key : "";
      reqObj.serialNumberId = serialId;
      reqObj.serialNumberLength = serialLength;
      return reqObj;
    }
    return null;

  }

  const handleAddTScheme = async () => {
    let reqObj: any = getRequestObject();
    console.log(reqObj);
    if (reqObj) {
      let data = await addTagScheme(reqObj);
      if (data?.response?.data?.errorMessage) {
        if (data?.response?.data?.errorMessage === 'TAG_SCHEME_ALREADY_EXISTS') {
          ToastManager.showToast(data.response.data.errorMessage, "Tag Scheme Name already in use");
        }
        ToastManager.showToast(data.response.data.errorMessage, "Error");
        return;
      }
      if (data) {
        handleClose(false);
        getTagSchemeist();
        ToastManager.showToast("Tag Scheme Created Successfully", "Success");
      }
    }
  }

  const handleEditTagScheme = async () => {

    let reqObj: any = getRequestObject();
    reqObj.tagSchemeId = schemeToEdit.tagSchemeId;
    console.log(reqObj);
    if (reqObj) {
      let data = await editTagScheme(reqObj);
      if (data?.response?.data?.errorMessage) {
        ToastManager.showToast(data.response.data.errorMessage, "Error");
        return;
      }
      if (data) {
        handleClose(false);
        getTagSchemeist();
        ToastManager.showToast("Tag Scheme Created Successfully", "Success");
      }
    }
  }

  let onClickDeleteTagScheme = () => {
    setDelTagSchme(true);
  }

  let handletagStatus = (data: any) => {
    setTagSchemeStatus(data);
    if (data) {
      setTagStatusError(false);
    } else {
      setTagStatusError(true);
    }
  }
  let onChangeScheme = (e: any) => {
    setSchemeName(e);
    if (e) {
      setTrackIdErr(false);
    } else {
      setTrackIdErr(true);
    }
  }
  let onChangeDescription = (e: any) => {
    setTagDesc(e);
  }
  let onChangeTagId = (e: any) => {
    setTagId(e);
  }
  let onChangeHeaderFormat = (data: any) => {
    setHeaderFormat(data);
    if (data) {
      setHeaderFormatError(false);
    } else {
      setHeaderFormatError(true);
    }
  }
  let onChangeHeaderLength = (data: any) => {
    setHeaderLength(data);
    if (data) {
      setHeaderLengthError(false);
    } else {
      setHeaderLengthError(true);
    }
  }

  let onChangeHeaderId = (data: any) => {
    setHeaderId(data);
    if (data) {
      seteHaderIdError(false);
    } else {
      seteHaderIdError(false);
    }
  }
  let onChangeSerialID = (e: any) => {
  onChangeSerialId(e.target.value);
  setTagId(headerId + serialId);
  setSerialIdError(false)
  }

  let onChangeSerialFormat = (data: any) => {
    setSerialFormat(data);
    if (data) {
      setSerialFormatError(false);
    } else {
      setSerialFormatError(true);
    }
  }
  let onChangeSerialLength = (data: any) => {
    setSerialLength(data);
    if (data) {
      setSerialLengthError(false);
    } else {
      setSerialLengthError(true);
    }
  }
  let onChangeSerialId = (data: any) => {
    setSerialId(data);
  }

  let handleDeleteTagScheme = async (tScheme: any) => {
    console.log(tScheme);
    let data = await deleteTagScheme(tScheme);
    if (data?.response?.data?.errorMessage) {
      ToastManager.showToast(data.response.data.errorMessage, "Error");
      return;
    }
    if (data) {
      handleClose(false);
      getTagSchemeist();
      ToastManager.showToast("Tag Scheme Deleted Successfully", "Success");
    }
  }

  let closeDelTagSchemePopup = () => {
    setDelTagSchme(false);
  }

  let getList = () => {

  }

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <>
        {delTagScheme && <DeleteModal title={"Delete Tag Scheme"} open={delTagScheme} handleDelete={handleDeleteTagScheme} handlePopupClose={closeDelTagSchemePopup} role={schemeToEdit} getList={getList} />}
        <Box sx={styles.container}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          {error !== "" && <Typography sx={{ color: "red", fontSize: ".7rem" }}>{error}</Typography>}
          <Grid item xs={12} sx={styles.header}>
            <h2>{schemeToEdit !== null ? "Edit Tag Scheme" : "Add Tag Scheme"}</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>

          <Grid container spacing={5}>
            <Grid item xs={12} className="truckContainer" >
              <Typography sx={styles.subHeader} style={{ marginTop: "0px", fontWeight: "bold" }}>Create Tag Scheme</Typography>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6}>
                  <TextField style={{ width: "100%", paddingBottom: "0px" }} inputProps={{ maxLength: 30 }} label={"Name"} value={schemeName}
                             onChange={(e) => onChangeScheme(e.target.value)} required={true} error={trackIdErr} />
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Status"} sKey={"key"} value={"value"} selectedValue={tagSchemeStatus}  dataSource={tagStatuses}
                                  mandatory={true} iserror={tagStatusError} onChangeHandler={(e: any) => handletagStatus(e)} />
                </Grid>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={12}>
                  <TextField style={{ width: "100%", paddingBottom: "0px" }} inputProps={{ maxLength: 120 }} label={"Description"} value={tagDesc}
                             onChange={(e) => onChangeDescription(e.target.value)}  required={false} error={false} multiline={true} />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={12}>
                  <TextField style={{ width: "100%", paddingBottom: "0px" }} inputProps={{ maxLength: 30 }} label={"ID"} value={tagId}
                             onChange={(e) => onChangeTagId(e.target.value)} required={false} error={false} disabled  />
                </Grid>
              </Grid>

              <Typography sx={styles.subHeader} style={{ marginTop: "0px", fontWeight: "bold" }}>Header <span style={{ color: "#b2afaf", fontWeight: "normal" }}>(Type: Fixed)</span> </Typography>
              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Format"} sKey={"key"} value={"value"}  dataSource={headerFormats} selectedValue={headerFormat}
                                  mandatory={true} iserror={headerFormatError}
                                  onChangeHandler={(e: any) => onChangeHeaderFormat(e)} />
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TextField style={{ width: "100%", paddingBottom: "0px" }} type={"number"} inputProps={{ maxLength: 30 }} label={"Length"} value={headerLength}
                             onChange={(e) => onChangeHeaderLength(e.target.value)} required={true} error={headerLengthError} />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={styles.subContainer}>

                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TextField style={{ width: "100%", paddingBottom: "0px" }} label={"ID"} inputProps={{ maxLength: 30 }} value={headerId}
                             onChange={(e) => onChangeHeaderId(e.target.value)} required={false} error={headerIdError} />
                </Grid>
              </Grid>

              <Typography sx={styles.subHeader} style={{ marginTop: "0px", fontWeight: "bold" }}>Serial Number<span style={{ color: "#b2afaf", fontWeight: "normal" }}> (Type: sequence)</span></Typography>

              <Grid container spacing={2} sx={styles.subContainer}>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TruckMuiSelect label={"Format"} sKey={"key"} value={"value"}  dataSource={serialFormats} selectedValue={serialFormat}
                                  mandatory={true} iserror={serialFormatError}
                                  onChangeHandler={(e: any) => onChangeSerialFormat(e)} />
                </Grid>
                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TextField style={{ width: "100%", paddingBottom: "0px" }} type={"number"} inputProps={{ maxLength: 30 }} label={"Length"} value={serialLength}
                             onChange={(e) => onChangeSerialLength(e.target.value)} required={true} error={serialLengthError} />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={styles.subContainer}>

                <Grid item xs={6} sx={{ marginBottom: 0 }}>
                  <TextField style={{ width: "100%", paddingBottom: "0px" }} inputProps={{ maxLength: 30 }} label={"ID"} value={serialId}
                             onChange={onChangeSerialID} required={false} error={serialIdError} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>Cancel</Button>
            {(schemeToEdit !== null && CommonUtil.isScreenButtonAvailable(CommonUtil.TAG_SCHEME_MANAGER, CommonUtil.UPDATE_MODE)) ? <Button sx={styles.deleteButton} onClick={onClickDeleteTagScheme}>Delete Scheme</Button> : ""}
            {(schemeToEdit != null && CommonUtil.isScreenButtonAvailable(CommonUtil.TAG_SCHEME_MANAGER, CommonUtil.UPDATE_MODE)) ? <Button sx={styles.addButton} onClick={handleEditTagScheme}>{"Edit Scheme"}</Button> : ""}
            {(!schemeToEdit && CommonUtil.isScreenButtonAvailable(CommonUtil.TAG_SCHEME_MANAGER, CommonUtil.UPDATE_MODE)) ? <Button sx={styles.addButton} onClick={handleAddTScheme}>{"Add Scheme"}</Button> : ""}
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default TagSchemeModal;